import th from '../th.json' with { type: 'json' };
import en from '../en.json' with { type: 'json' };

export const locales = { th, en } as const;
export type Locale = keyof typeof locales;

type Tree = { [k: string]: string | Tree };

/** Flattens a message tree into dotted keys, e.g. `auth.notProvisioned.staff`. */
export function flattenKeys(tree: Tree, prefix = ''): string[] {
  return Object.entries(tree).flatMap(([k, v]) => {
    const key = prefix ? `${prefix}.${k}` : k;
    return typeof v === 'string' ? [key] : flattenKeys(v, key);
  });
}

/** Keys present in one locale but not the other. Empty arrays mean parity. */
export function parityReport(a: Tree, b: Tree): { onlyInA: string[]; onlyInB: string[] } {
  const ka = new Set(flattenKeys(a));
  const kb = new Set(flattenKeys(b));
  return { onlyInA: [...ka].filter((k) => !kb.has(k)).sort(), onlyInB: [...kb].filter((k) => !ka.has(k)).sort() };
}
